import { render, staticRenderFns } from "./milestone-stage-status-item.vue?vue&type=template&id=0739bb6a&"
import script from "./milestone-stage-status-item.vue?vue&type=script&lang=ts&"
export * from "./milestone-stage-status-item.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports